module.exports = __webpack_public_path__ + "static/media/gdBee.2f512369.jpg";